module.exports = __webpack_public_path__ + "img/P150T_weapon_90.4c6e8970.png";